import { PuzzleIcon } from "@heroicons/react/outline";
import { cn } from "@/lib/utils";

export interface ExtensionItem {
	name: string;
	category?: string;
}

interface ExtensionsPanelProps {
	features: ExtensionItem[];
	totalCount?: number;
	title?: string;
	className?: string;
}

const FEATURE_COLOR = { accent: "bg-blue-500", bg: "bg-blue-50", text: "text-blue-800" };

const ExtensionsPanel = ({
	features,
	totalCount,
	title = "Επεκτάσεις",
	className,
}: ExtensionsPanelProps) => {
	const countLabel = totalCount !== undefined
		? `${features.length} / ${totalCount} ενεργές`
		: `${features.length} ενεργές`;

	return (
		<div className={cn("flex max-h-80 flex-col py-4 px-5", className)}>
			{/* Header row: icon + title + count badge */}
			<div className="flex shrink-0 items-center gap-2 mb-4">
				<div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-indigo-100">
					<PuzzleIcon className="h-4 w-4 text-indigo-600" />
				</div>
				<span className="text-lg font-semibold text-gray-800">{title}</span>
				<span className="ml-auto whitespace-nowrap rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
					{countLabel}
				</span>
			</div>

			{/* Feature list */}
			{features.length === 0 ? (
				<div className="flex flex-1 flex-col items-center justify-center gap-1.5 rounded-lg border border-dashed border-gray-200 py-6">
					<PuzzleIcon className="h-6 w-6 text-gray-300" />
					<p className="text-xs text-gray-400">Καμία ενεργή επέκταση</p>
				</div>
			) : (
				<ul className="space-y-1.5 overflow-y-auto">
					{features.map((feature) => {
						const color = FEATURE_COLOR;
						return (
							<li
								key={feature.name}
								className={cn(
									"flex items-center gap-2.5 rounded-lg px-3 py-2 transition-colors",
									color.bg,
								)}
							>
								<span className={cn("h-2 w-2 shrink-0 rounded-full", color.accent)} />
								<span className={cn("text-sm font-medium", color.text)}>
									{feature.name}
								</span>
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
};

export default ExtensionsPanel;
